import {SelectOption} from '@hconnect/common/types'
import moment from 'moment-timezone'

import {
  WorkOrder,
  WorkOrderDto,
  WorkOrderPagedContainer,
  WorkOrderPagedContainerDto,
  AggregatedWorkOrdersByRevisionCodeDto
} from '../types'

export const getIdToRender = (id: string) => id.replace(/^[^2-9]*([2-9]\d*)/, '$1')
export const mapWorkOrder = (workOrder: WorkOrderDto, timezone: string): WorkOrder => ({
  ...workOrder,
  createdAt: moment.utc(workOrder.createdAt).tz(timezone),
  startDate: moment.utc(workOrder.startDate).tz(timezone),
  endDate: moment.utc(workOrder.endDate).tz(timezone),
  functionalLocation: workOrder.functionalLocation
    ? {
        ...workOrder.functionalLocation,
        id: getIdToRender(workOrder.functionalLocation.id),
        idType: 'sapNumber'
      }
    : undefined,
  ...(workOrder.equipment && {equipment: {...workOrder.equipment, idType: 'sapNumber'}})
})

export const mapWorkOrderPagedContainerDto = (
  workOrdersData: WorkOrderPagedContainerDto,
  timezone: string
): WorkOrderPagedContainer => ({
  ...workOrdersData,
  items: workOrdersData.items.map((workOrder) => mapWorkOrder(workOrder, timezone))
})
export const mapToRevisionCodesArray = (data: AggregatedWorkOrdersByRevisionCodeDto): string[] =>
  data.workOrderByRevisionCodeSummaries.map((revisionCode) => revisionCode.revisionCode)

export const mapToRevisionCodeOptions = (
  revisionCodes: string[] | undefined = []
): SelectOption<string>[] => {
  return revisionCodes.map((revisionCode) => ({
    label: revisionCode,
    value: revisionCode
  }))
}
